import type { SbContentMutator } from '../mutationHelpers';
import { getShippingRate } from '$lib/utils/stripe';
import type { MutatorCache, PromiseCache } from '../api';
import type { Stripe } from 'stripe';
import { PUBLIC_APP_ENV } from '$env/static/public';

const fieldName = PUBLIC_APP_ENV === 'prod' ? 'shipping_id' : 'shipping_id_stage';

export function stripeShippingMutator(
	serverFetch: typeof fetch,
	cache: MutatorCache['shipping'],
	promiseCache: PromiseCache['shipping']
): SbContentMutator<{
	shipping_id: string;
	shipping_id_stage: string;
	stripeShippingData: Stripe.ShippingRate;
}> {
	return {
		check: (_, content) => typeof content === 'object' && fieldName in content,
		mutate: async (_, content) => {
			const key = content[fieldName];

			if (cache[key]) {
				content.stripeShippingData = cache[key];
				return;
			}

			const existingPromise = promiseCache[key];
			if (existingPromise) {
				content.stripeShippingData = await existingPromise;
				return;
			}

			const shippingPromise = getShippingRate(key, serverFetch).then((data) => {
				cache[key] = data;
				return data;
			});

			promiseCache[key] = shippingPromise;

			try {
				content.stripeShippingData = await shippingPromise;
			} catch (error) {
				console.error(`Error fetching Stripe shipping rate for ${key}:`, error);
				throw error;
			}
		}
	};
}
